import type { FaireProductEntity } from "../../entity_types/product";

export const p_j2ru6uz5cy: FaireProductEntity = {
  token: "p_j2ru6uz5cy",
  type: "product",
  name: "Textured Open Front Oversize Midi Sweater Cardigan (S-XL)",
  brandToken: "b_fpqcwkn7v8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a9fc66bebf199302fb48e34c670529742d09c270f56c7b52a24bf8e299726e71.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b13ded6da4579ef2b7b11f3e8b089289aa5e07f81f26b8941200e33c3240616f.jpeg",
    "https://cdn.faire.com/fastly/51b05e948101179eabb223eaf61bf24bdb4bb448e96b0b6dcc27e346dfe6d6c5.jpeg",
    "https://cdn.faire.com/fastly/090e1ccfc4c5ff682725d0b40f852aef766b98153d6aee620b4d75fea8907f5a.jpeg",
    "https://cdn.faire.com/fastly/b54954dfd4476f4078f8ecd3857071c048d4bfaede496d573e2f5bda9660a799.jpeg",
    "https://cdn.faire.com/fastly/91eebb9f1bded4dcf808c5c3cb48add7361007d7dd9ae0d856c97682833ec4f2.jpeg",
    "https://cdn.faire.com/fastly/06f127877e2a2486c5852381f6b7a70cac214d30e4aeafab18438549165cd43a.jpeg",
    "https://cdn.faire.com/fastly/d06187c2fd79748e26697dfba2e9ae5b5b108c727a4eee17c0df2f3851aaf3cf.jpeg",
  ],
  priceDollars: 41.23,
  description:
    "🎀Material: 100%Cotton\n😍Why You’ll Love It?\n\nSolid color textured knit offers a versatile, timeless style.  \nOpen front design allows for easy layering and effortless wear.  \nOversized midi silhouette provides a cozy, relaxed fit.  \nPerfect for casual outings, layering over dresses, or lounging in comfort.  \n\n💌Note: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options!",
  tags: [],
  msrpDollars: 82.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:51.799Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
